import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { ToastService } from '@blocks/large-toast/toast.service';
import { LoginService } from '@core/auth/services/login.service';
import { PermissionsService } from '@core/services/utility/permissions.service';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        public toasterService: ToastService,
        private loginService: LoginService,
        public router: Router,
        private permissionService: PermissionsService,
    ) { }

    // authentication
    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return await this.authenticationUser(route, state);
    }

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return await this.authenticationUser(route, state);
    }

    private async authenticationUser(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (!this.loginService.isAuthenticated()) {
            if (environment.isCommonLoginEnabled) {
                window.location.href = `${environment.commonLoginPortalUrl}/incoming-request-receiver?redirectUrl=${state.url.substring(1).replaceAll("&", "[AND]")}&sourceProduct=RISK&isExternal=true`;
            }
            else {
                console.debug(route);
                this.router.navigate(['auth', 'login']);
            }

            return false;
        }

        if (environment.isPermissionOn) {
            await this.permissionService.setStaticPermissionsToState();
            await this.permissionService.setServicePermissionsToState();
            await this.permissionService.setInterplanPermissionsToState();
        }

        return true;
    }
}
